import React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { Clock3, ReceiptText, X } from 'lucide-react';
import GuestTableBill from './GuestTableBill';
import { money } from './menuData';

export default function GuestOrders({ tableToken, themeStyle, open, onOpenChange, pending, onCheck }) {
  return <Dialog.Root open={open} onOpenChange={onOpenChange}><Dialog.Portal>
    <Dialog.Overlay className="guest-dialog-overlay" />
    <Dialog.Content className="guest-product-dialog guest-basket-dialog guest-orders-dialog" style={themeStyle}>
      <div className="guest-basket-header"><div><span className="guest-menu-eyebrow"><ReceiptText size={14} aria-hidden="true"/>At your table</span><Dialog.Title>Table order</Dialog.Title><Dialog.Description>One combined order for everyone at your table during this visit.</Dialog.Description></div><Dialog.Close asChild><button className="guest-basket-close" aria-label="Close table order"><X size={21} /></button></Dialog.Close></div>
      <div className="guest-basket-body">
        {pending&&<div className="guest-order-receipt"><Clock3 size={20} aria-hidden="true"/><div><strong>Items awaiting confirmation</strong><p>{money(pending.expected_total)} · These items may not appear below yet. Check before sending them again.</p><button className="guest-text-button" onClick={onCheck}>Check submission</button></div></div>}
        <GuestTableBill tableToken={tableToken} open={open}/>
      </div>
    </Dialog.Content>
  </Dialog.Portal></Dialog.Root>;
}
